/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2025, Zumper
 * @description SearchItem
 */

import { Clock, ZoeSparkle } from '@zcode-ui/icons'
import { Button, cn } from '@zcode-ui/shadz-ui'
import React from 'react'

export const SearchItem = ({
  handleSubmit,
  isRecentSearch,
  searchText,
}: {
  handleSubmit: (searchText: string, searchTextType: 'recent' | 'suggestion') => void
  isRecentSearch?: boolean
  searchText: string
}) => {
  return (
    <div className="pl-1 pr-1 hover:pl-[2px] hover:border-l-[2px] hover:border-solid hover:border-pink-600 hover:bg-gray-50">
      <Button
        className="w-full flex gap-2 px-3 items-center justify-start min-h-14 rounded-none cursor-pointer  hover:bg-transparent whitespace-normal h-auto"
        onClick={() => handleSubmit(searchText, isRecentSearch ? 'recent' : 'suggestion')}
        tabIndex={0}
        variant="ghost"
      >
        <div
          className={cn(
            'flex shrink-0 items-center justify-center rounded-md bg-pink-50 w-10 h-10',
            isRecentSearch && 'bg-neutral-100'
          )}
        >
          {isRecentSearch ? <Clock size={18} stroke="#50788B" /> : <ZoeSparkle size={20} />}
        </div>
        <p
          className={cn(
            'text-gray-800 md:text-sm text-base font-medium leading-6 text-left',
            isRecentSearch && 'text-blue-800'
          )}
        >
          {searchText}
        </p>
      </Button>
    </div>
  )
}
